import i18n from '@/language/i18n';
import get from 'lodash/get';
import dateFormatter from '@/services/formatter_services/date-formatter';

const nameFormat = ({ firstname, lastname }) => {
  const hasNoFirstname = (!firstname || firstname === "");
  const hasNoLastname = (!lastname || lastname === "");

  if (hasNoFirstname && hasNoLastname) { return null; }
  return [lastname, firstname].filter(val => val).join(', ');
}

const matchCodeLabelFormat = (item) => {
  let matchCode = get(item, 'matchCode') ?? get(item, 'data.matchCode');
  let label = get(item, 'label') ?? get(item, 'data.label');
  return [matchCode, label].filter(val => val).join(' - ');
};

const noHtmlTagsFormat = (text) => {
  return text?.replace(/<[^>]*>/g, "");
}

const formatValidUntil = (value) => {
  if (value === null || value === undefined) {
    return i18n.t('Common.unlimited');
  }
  return dateFormatter.formatDateToLocaleDateStringNoTime(value);
}

export { nameFormat, matchCodeLabelFormat, noHtmlTagsFormat, formatValidUntil };
